import { Component, OnInit, Input } from '@angular/core';
import { ShoppingCartService } from 'src/app/core/services/shoppingCart.service';
import { NavService } from 'src/app/core/services/nav.service';
import { RestaurantService } from 'src/app/core';

@Component({
	selector: 'cart',
	templateUrl: './cart.component.html',
	styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {

	products = [];

	isNewFlowCheckout: boolean = !!this.restaurantService.restaurant?.info?.modules?.new_flow_checkout_pedir_delivery;

	constructor(
		private cartService: ShoppingCartService,
		private navService: NavService,
		private restaurantService: RestaurantService
	) { }

	ngOnInit() {
		this.products = this.cartService.products;
		this.cartService.cartProductsChanged.subscribe(result => this.products = result);
	}

	get cartTotal(): number {
		return this.cartService.total();
	}

	async openShoppingCart() {
		this.navService.push('shopping-cart');
	}

}
